import apiClient from '@/services/rest-api-sms/apiClient'
const baseEndpoint = '/vehicle'

export const update = async (id, sensor_code, pin_code, data, region) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}/sensor/${sensor_code}/${pin_code}`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const remove = async (id, sensor_code, pin_code, data, region) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/${id}/sensor/${sensor_code}/${pin_code}`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const create = async (id, data, region) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/${id}/sensor`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}
